import { Observable } from 'rxjs';
import { InvoiceAction } from '../enums/invoice-action.enum';
import { InvoiceExportRequest } from '../models/invoice-export.model';
import { InvoiceList } from '../models/invoice-list.model';
import { InvoiceRevenueEditData, InvoiceRevenueEditRequest } from '../models/invoice-revenue-edit.model';

export abstract class InvoiceRepository {
  abstract getInvoices(query: string): Observable<InvoiceList>;
  abstract getIssuedCount(): Observable<number>;
  abstract getErrorCount(): Observable<number>;
  abstract executeAction(invoiceId: number | string, action: InvoiceAction, serviceInvoiceIds?: (number | string | null)): Observable<void | Blob>;
  abstract exportCsv(request: InvoiceExportRequest): Observable<Blob>;
  abstract getRevenueEditData(revenueId: number): Observable<InvoiceRevenueEditData>;
  abstract updateRevenue(request: InvoiceRevenueEditRequest): Observable<InvoiceRevenueEditData>;
}
